import { useState } from "react";
import { motion } from "framer-motion";
import BrandMark from "@/components/BrandMark";

const LINKS = [
  { label: "Structure", href: "#structure" },
  { label: "Broker Advantage", href: "#broker-advantage" },
  { label: "Manifesto", href: "#manifesto" },
];

export default function NavigationHeader() {
  const [open, setOpen] = useState(false);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      className="fixed top-0 inset-x-0 z-50 bg-[#07090D]/80 backdrop-blur-xl border-b border-white/10"
      data-testid="navigation-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 sm:h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 group" data-testid="brand-logo-link">
          <span className="w-1 h-8 bg-amber-500 rounded-sm transition-transform duration-300 group-hover:scale-y-125" />
          <BrandMark />
        </a>

        <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-xs font-mono-d tracking-[0.2em] uppercase text-zinc-400 hover:text-amber-400 transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <span className="hidden lg:flex items-center gap-2 text-xs font-mono-d text-zinc-500 border-l border-white/10 pl-8">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
            $340M+ brokered
          </span>
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#pre-approval"
            data-testid="nav-cta-button"
            className="hidden sm:inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-400 text-[#07090D] text-sm font-semibold px-5 py-2.5 rounded-sm transition-all duration-300 hover:-translate-y-0.5"
          >
            Check Pre-Approval Status
          </a>
          <button
            className="md:hidden text-zinc-300 p-2"
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            <div className="w-5 h-px bg-current mb-1.5" />
            <div className="w-5 h-px bg-current mb-1.5" />
            <div className="w-5 h-px bg-current" />
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-[#07090D]/95 px-6 py-6 space-y-4" data-testid="mobile-menu">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block text-sm font-mono-d tracking-[0.2em] uppercase text-zinc-300"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#pre-approval"
            onClick={() => setOpen(false)}
            data-testid="mobile-cta-button"
            className="block text-center bg-amber-500 text-[#07090D] font-semibold px-5 py-3 rounded-sm"
          >
            Check Pre-Approval Status
          </a>
        </div>
      )}
    </motion.header>
  );
}
